import $ from 'jquery'
function toggleButton(target){
    const addClass = 'active'
    const removeClass = 'selected'
    if (target.hasClass(addClass)){
        target.addClass(removeClass)
        target.removeClass(addClass)
    }else{
        target.addClass(addClass)
        target.removeClass(removeClass)
    }
}

export function attachToggleActionButton(managePromise){
    const el = $('.toggle-action-button')
    el.click(function(event){
        const target = $(event.currentTarget)
        let action = 'add'
        if (target.hasClass('selected')) action = 'remove'
        const id = target.data("manageditemid")
        managePromise(id, action)
            .then(resp => {
                if (typeof resp === 'undefined') return
                toggleButton(target)
            })
    })
}